import e from "../../managers/braze-instance.js";
import { destroyFeed, showFeed } from "../index.js";
export function toggleFeed(o, n, r) {
  e.rr() &&
    (document.querySelectorAll(".ab-feed").length > 0
      ? destroyFeed()
      : showFeed(o, n, r));
}
